import React from 'react';
import { Link } from 'gatsby';

const Navbar = () => (
  <nav className="navbar is-transparent">
    <div className="container">
      <div className="navbar-brand">
        <Link to="/" className="navbar-item">
          `e.schapp.co`
        </Link>
      </div>
      <div className="navbar-start">
      </div>
      <div className="navbar-end">
        <Link to="/about" className="navbar-item">
          about
        </Link>
      </div>
    </div>
  </nav>
);

export default Navbar;
